<!--云稼乡村  -->
<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner" />
      </el-carousel-item>
    </el-carousel>

    <!-- 产品介绍 -->
    <div class="country_introduce_bg">
      <div class="country_introduce_left">
        <div class="country_introduce_title">产品介绍</div>
        <div class="country_introduce_content">
          从食、住、游、娱、购物、大健康等角度发力，将分布在城市周边的“农庄、民宿、果园、生态园、观光园、农家乐、钓鱼场、游乐场、康养所”等乡村旅游线下资源整合在一个平台上，实现线上一站式服务，吸引城市消费者体验乡村生活，以信息流带动乡村人流、物流、技术流、资金流，共同推进地方经济发展
        </div>
      </div>
      <img
        class="country_introduce_img"
        src="../../../static/other/ic_country_introduce.png"
      />
    </div>
    <!-- 乡村旅游面临的问题 -->
    <div class="country_problem_bg">
      <div class="country_problem_title">乡村旅游面临的问题</div>
      <img
        class="country_problem_img"
        src="../../../static/other/ic_country_problem.png"
      />
    </div>
    <!-- 乡村生活服务平台 -->
    <div class="country_serve_bg">
      <div class="country_serve_title">乡村生活服务平台</div>
      <div class="country_serve_tabes">
        <el-tabs v-model="serve_activeId" tab-position="left">
          <el-tab-pane
            v-for="(item, sIndex) in subjectList"
            :key="sIndex"
            :name="sIndex + ''"
          >
            <template slot="label">
              <div class="country_serve_tabs_text">
                <div style="width: 40px">{{ item.tabName }}</div>
                <div
                  class="country_serve_right_bg"
                  v-if="serve_activeId == sIndex"
                >
                  <img
                    class="country_serve_right_img"
                    src="../../../static/other/ic_country_serve_right.png"
                  />
                </div>
              </div>
            </template>
            <div class="country_serve_bottom">
              <div class="country_serve_bottom_img_parent">
                <img class="country_serve_bottom_img" :src="item.img" />
              </div>
              <div class="country_serve_bottom_right">
                <div class="country_serve_bottom_right_title">
                  {{ item.title }}
                </div>
                <div class="country_serve_bottom_right_content">
                  {{ item.content }}
                </div>
                <div class="country_serve_bottom_right_img_parent">
                  <div
                    class="country_serve_bottom_right_text"
                    v-for="(item_img, index) in item.imgList"
                    :key="index"
                  >
                    <img
                      class="country_serve_bottom_right_img"
                      :src="item_img.img"
                    />
                    {{ item_img.text }}
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 功能 -->
    <div class="country_function_bg">
      <div class="country_function_top_bg">
        <div class="country_function_center">
          <div class="country_function_left">
            <div class="country_function_left_title">九大功能</div>
            <div class="country_function_left_content">
              设计有辅助功能<br />提升乡村生活体验感
            </div>
          </div>
          <img
            class="country_function_img"
            src="../../../static/other/ic_country_function_img.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      serve_activeId: "0",
      subjectList: [
        {
          tabName: "美食",
          img: require("../../../static/other/ic_country_serve_img1.png"),
          title: "云稼美食",
          content:
            "乡村生活服务平台可为游客提供：农家乐、果园采摘、乡村攻略、定位导航、信息分享、农副产品销售、线路推荐、民宿预订、土家菜推荐等服务。在满足游客需求的同时，提供个性化定制，突出乡村旅游的特色，拓宽乡村旅游宣传渠道",
          imgList: [
            {
              text: "美食",
              img: require("../../../static/other/ic_country_serve_bottom_img1.png"),
            },
          ],
        },
        {
          tabName: "民宿",
          img: require("../../../static/other/ic_country_serve_img2.png"),
          title: "云稼民宿",
          content:
            "乡村生活服务平台可为游客提供：农家乐、果园采摘、乡村攻略、定位导航、信息分享、农副产品销售、线路推荐、民宿预订、土家菜推荐等服务。在满足游客需求的同时，提供个性化定制，突出乡村旅游的特色，拓宽乡村旅游宣传渠道",
          imgList: [
            {
              text: "民宿",
              img: require("../../../static/other/ic_country_serve_bottom_img2.png"),
            },
          ],
        },
        {
          tabName: "景点",
          img: require("../../../static/other/ic_country_serve_img3.png"),
          title: "云稼旅游",
          content:
            "乡村生活服务平台可为游客提供：农家乐、果园采摘、乡村攻略、定位导航、信息分享、农副产品销售、线路推荐、民宿预订、土家菜推荐等服务。在满足游客需求的同时，提供个性化定制，突出乡村旅游的特色，拓宽乡村旅游宣传渠道",
          imgList: [
            {
              text: "旅游",
              img: require("../../../static/other/ic_country_serve_bottom_img3.png"),
            },
          ],
        },
        {
          tabName: "娱乐",
          img: require("../../../static/other/ic_country_serve_img3.png"),
          title: "云稼娱乐",
          content:
            "乡村生活服务平台可为游客提供：农家乐、果园采摘、乡村攻略、定位导航、信息分享、农副产品销售、线路推荐、民宿预订、土家菜推荐等服务。在满足游客需求的同时，提供个性化定制，突出乡村旅游的特色，拓宽乡村旅游宣传渠道",
          imgList: [
            {
              text: "娱乐",
              img: require("../../../static/other/ic_country_serve_bottom_img4.png"),
            },
          ],
        },
        {
          tabName: "购物",
          img: require("../../../static/other/ic_country_serve_img5.png"),
          title: "云稼电商",
          content:
            "标准移动端商城模块，消费者可快捷完成商品查询、商品选择、下单、支付、物流查询、确认收货、售后服务等一系列网购环节，足不出户即可轻松购买地方特色农产品以及生活类商品",
          imgList: [
            {
              text: "购好货",
              img: require("../../../static/other/ic_country_serve_bottom_img5.png"),
            },
            {
              text: "平台优选",
              img: require("../../../static/other/ic_country_serve_bottom_img6.png"),
            },
          ],
        },
        {
          tabName: "大健康",
          img: require("../../../static/other/ic_country_serve_img6.png"),
          title: "云稼大健康",
          content:
            "与地方康养、医疗、保险机构合作，提供线下配套且成熟的健康服务；同时对接第三方服务平台，提供在线化的康养、医疗、保险相关服务",
          imgList: [
            {
              text: "康养",
              img: require("../../../static/other/ic_country_serve_bottom_img7.png"),
            },
            {
              text: "保险",
              img: require("../../../static/other/ic_country_serve_bottom_img8.png"),
            },
            {
              text: "医疗",
              img: require("../../../static/other/ic_country_serve_bottom_img9.png"),
            },
          ],
        },
      ],
    };
  },

  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height: 100%;
}
.country_introduce_bg {
  background: #f3f5fa;
  height: 420px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  .country_introduce_left {
    display: flex;
    flex-direction: column;
    margin-top: 130px;

    .country_introduce_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      color: #333333;
      margin-bottom: 8px;
    }
    .country_introduce_content {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #666666;
      width: 730px;
    }
  }
  .country_introduce_img {
    width: 339px;
    height: 316px;
    margin-top: 48px;
    margin-left: 80px;
  }
}

.country_problem_bg {
  display: flex;
  height: 600px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;

  .country_problem_title {
    width: auto;
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    margin-top: 30px;
  }

  .country_problem_img {
    width: 1068px;
    height: 525px;
    margin-left: -40px;
  }
}

.country_serve_bg {
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;

  .country_serve_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 48px;
  }
  .country_serve_tabes {
    width: 1180px;
    margin-bottom: 80px;
    >>> .el-tabs__nav-scroll {
      background-color: #f3f5fa;
    }
    /* 去除最底部下划线 */
    >>> .el-tabs__nav-wrap::after {
      position: static !important;
    }
    /*隐藏tab下面的一横*/
    >>> .el-tabs__active-bar {
      background-color: transparent !important;
    }
    >>> .el-tabs__nav {
      margin: 30px 0;
    }
    >>> .el-tabs__item {
      width: 150px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 10px;
      padding-left: 24px;
      padding-right: 10px;
    }
    >>> .el-tabs__item:hover {
      color: #333333;
    }
    /*选中样式*/
    >>> .el-tabs__item.is-active {
      width: 150px;
      height: 48px;
      border-radius: 28px;
      font-size: 20px;
      text-align: center;
      color: #ffffff;
      background-color: #3370ff;
      margin-bottom: 10px;
      padding-left: 24px;
      padding-right: 10px;
    }

    .country_serve_tabs_text {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .country_serve_right_bg {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        width: 28px;
        height: 28px;
        border-radius: 14px;
        .country_serve_right_img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .country_serve_bottom {
      display: flex;
      flex-direction: row;
      background: #ffffff;
      border-radius: 4px;
      height: 400px;
      margin-left: 32px;

      .country_serve_bottom_img_parent {
        width: 390px;
        .country_serve_bottom_img {
          width: auto;
          height: 310px;
          margin-top: 50px;
          margin-left: 80px;
        }
      }
      .country_serve_bottom_right {
        display: flex;
        flex-direction: column;
        margin-top: 80px;
        .country_serve_bottom_right_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          color: #333333;
          margin-bottom: 12px;
        }
        .country_serve_bottom_right_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #666666;
          width: 480px;
        }
        .country_serve_bottom_right_img_parent {
          display: flex;
          flex-direction: row;
          margin-top: 36px;
          .country_serve_bottom_right_text {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: "PingFang SC";
            margin-right: 26px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            .country_serve_bottom_right_img {
              width: 36px;
            }
          }
        }
      }
    }
  }
}

.country_function_bg {
  width: 100%;
  background: #ffffff;
  .country_function_top_bg {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 530px;
    margin-bottom: 160px;
    background: url("../../../static/other/bg_country_function_top.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center 0;

    .country_function_center {
      display: flex;
      flex-direction: row;
      width: 1180px;

      .country_function_left {
        display: flex;
        flex-direction: column;
        margin-top: 100px;
        .country_function_left_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          margin-bottom: 8px;
        }
        .country_function_left_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: #666666;
        }
      }
      .country_function_img {
        width: 870px;
        height: 450px;
        margin-left: 150px;
        margin-top: 80px;
      }
    }
  }
}
</style>